/* eslint-disable camelcase */
import { trackClick } from "@companion-core/shared/app/tracking/index";
import ChaptersEnum from "@companion-core/shared/app/tracking/enums/chapters";
import ClicksEnum from "@companion-core/shared/app/tracking/enums/clicks";
import LevelsEnum from "@companion-core/shared/app/tracking/enums/levels";
import ClickTypes from "@companion-core/shared/app/tracking/enums/click-types";
import { BookingCTATrackingProps, Click } from "@companion-core/shared/app/Interfaces/tracking";

export const trackBookingCTA = ({
  fulfillmentMode,
  vendorId,
  contentId,
  offerFunnelStepNumber,
}: BookingCTATrackingProps): Click => {
  return trackClick({
    click_type: ClickTypes.Navigation,
    click: `${ClicksEnum.OfferFunnelStepNumber}${offerFunnelStepNumber}`,
    click_chapter1: ChaptersEnum.Offer,
    click_chapter2: fulfillmentMode || "",
    click_chapter3: vendorId ? `${vendorId}_${contentId || ""}` : `${contentId || ""}`,
    site_level2: LevelsEnum.Contents,
  });
};
